import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  CircularProgress,
} from "@mui/material";

import SelectableSearch from "../../../Base/views/SelectableSearch";
import { grey } from "@mui/material/colors";
import { useDispatch, useSelector } from "react-redux";
import {
  AddManageGoalAction,
  GetManageGoalAction,
  GetMyGoalAction,
  UpdateManageGoalAction,
} from "../../../../../store/Employee/PMSystem/Action";
import CommonDatePicker from "../../../Base/views/CommonDatePicker";
import { GetGoalSubtypeHelper, GetGoalTypeHelper } from "../../../PerformanceSettings/helper/GoalCategoryHelper";
import { GetEmployeesHelper } from "../../../Employee/helper/EmployeeHelper";
import { getEmployeeId, isAdminOwner } from "../../../Base/helper/baseFunctions";

export default function CreateGoal({ currentGoal, closeMode, setOpenPopup, mode, value }) {
  const dispatch = useDispatch();
  const isPreview = mode === "Preview";
  const today = new Date();
  const initialValues = {
    goal_category_configuration_pk: "",
    goal_sub_category_configuration_pk: "",
    goal_desc: "",
    weight: null,
    alignment: "",
    employee_id: "",
    due_date: `${today.getFullYear() +"-" + ("0" + (today.getMonth() + 1)).slice(-2) + "-" + ("0" + today.getDate()).slice(-2)}`,
    goal_status: "",
  };

  const { minDojYear } = useSelector(
    (state) => state?.AncillaryReducer?.WorkSpaceDojReducer
  );
  const [goalData, setGoaldata] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const [addLoading, setAddLoading] = useState(false);
  const [employeesData, setEmployeesData] = useState({
    load: true,
    values: [],
  });
  const [typeData, setTypeData] = useState({
    load: true,
    values: [],
  });
  const [subTypeData, setSubTypeData] = useState({
    load: true,
    values: [],
  });
  const [Statusoptions] = useState({
    load: false,
    values: [
      { value: "Yet to Start", label: "Yet to Start" },
      { value: "In Progress", label: "In Progress" },
      { value: "Completed", label: "Completed" },
    ],
  });

  const validate = (fieldValues) => {
    let temp = { ...errors };
    if ("goal_desc" in fieldValues) {
      temp.goal_desc = fieldValues.goal_desc === "" ? "Goal is required" : "";
    }
    if ("goal_category_configuration_pk" in fieldValues) {
      temp.goal_category_configuration_pk =
        fieldValues.goal_category_configuration_pk === "" ? "Category is required" : "";
    }
    if ("goal_status" in fieldValues) {
      temp.goal_status =
        fieldValues.goal_status === "" ? "Status is required" : "";
    }
    if ("weight" in fieldValues) {
      temp.weight = fieldValues.weight === "" ? "Weightage is required" : "";
    }
    if ("goal_sub_category_configuration_pk" in fieldValues) {
      temp.goal_sub_category_configuration_pk =
        fieldValues.goal_sub_category_configuration_pk === "" ? "Goal is required" : "";
    }
    if ("alignment" in fieldValues) {
      temp.alignment =
        fieldValues.alignment === "" ? "Alignment is required" : "";
    }
    if ("employee_id" in fieldValues && goalData?.alignment === "Team") {
      temp.employee_id =
        fieldValues.employee_id === "" ? "Assign to is required" : "";
    }
    if ("due_date" in fieldValues) {
      temp.due_date = fieldValues.due_date === "" ? "Due Date is required" : "";
    }
    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };
  const handleInputChange = (event, value) => {
    if (
      ["goal_status", "employee_id", "alignment"].includes(
        event
      )
    ) {
      if (value && event === "alignment" && value === "Self") {
        setGoaldata({
          ...goalData,
          [event]: value,
          employee_id: "",
        });
      } else if (value) {
        setGoaldata({
          ...goalData,
          [event]: value,
        });
      }
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...goalData, [event]: value ? value : "" });
    } else if (["goal_sub_category_configuration_pk"].includes(event)) {
      if (value) {
        setGoaldata({ ...goalData, [event]: value });
      } else {
        setGoaldata({ ...goalData, [event]: "" });
      }
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...goalData, [event]: value ? value : "" });
    } else if (["goal_category_configuration_pk"].includes(event)) {
      if (value) {
        setGoaldata({
          ...goalData,
          [event]: value,
          goal_sub_category_configuration_pk: "",
        });
        setSubTypeData({ load: true, values: [] });
      } else {
        setGoaldata({ ...goalData, [event]: "" });
      }
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...goalData, [event]: value ? value : "" });
    } else if (["alignment"].includes(event.target.name)) {
      setGoaldata({
        ...goalData,
        [event.target.name]: event.target.value,
        employee_id: "",
      });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...goalData, [event]: value ? value : "" });
    } else {
      setGoaldata({
        ...goalData,
        [event.target.name]: event.target.value,
      });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...goalData, [event.target.name]: event.target.value });
    }
  };
  const handleCancel = () => {
    setOpenPopup(false);
    closeMode();
    setGoaldata(initialValues);
    setErrors([]);
  };
  const handlesubmit = () => {
    if (validate(goalData)) {
      setAddLoading(true);
      if (currentGoal?.goal_pk) {
        dispatch(
          UpdateManageGoalAction({...goalData,
            goal_sub_category_configuration_fk: goalData?.goal_sub_category_configuration_pk?.goal_sub_category_configuration_pk
          }, (error, result) => {
            setAddLoading(false);
            if (!error && result?.data?.statuscode === 200) {
              if(value === "1") {
                dispatch(GetMyGoalAction())
              }
              if(value === "2") {
                dispatch(GetManageGoalAction({alignment: "Team"}));
              }
              setGoaldata(initialValues);
              setOpenPopup(false);
            }
          })
        );
      } else {
        dispatch(
          AddManageGoalAction({...goalData,
            goal_sub_category_configuration_fk: goalData?.goal_sub_category_configuration_pk?.goal_sub_category_configuration_pk
          }, (error, result) => {
            setAddLoading(false);
            if (!error && result?.data?.statuscode === 200) {
              if(value === "1") {
                dispatch(GetMyGoalAction())
              }
              if(value === "2") {
                dispatch(GetManageGoalAction({alignment: "Team"}));
              }
              setGoaldata(initialValues);
              setOpenPopup(false);
            }
          })
        );
      }
    }
  };

  const handleEmployees = () => {
      GetEmployeesHelper({is_active: true}).then((res) => {
        if (res?.data?.statuscode === 200) {
          setEmployeesData({
            load: false,
            values: (res?.data?.data || [])?.filter(el => Number(el.employee_id) !== getEmployeeId()),
          });
        }
      });
  };
  const handleType = () => {
    GetGoalTypeHelper().then(res => {
      if (res?.data?.statuscode === 200) {
          setTypeData({ load: false, values: res?.data?.data || [] });
        } else {
          setTypeData({ load: false, values: [] });
        }
    })
  };
  const handleSubType = () => {
    if (goalData?.goal_category_configuration_pk?.goal_category_configuration_pk) {
      GetGoalSubtypeHelper({
        goal_category_id:
          `{${goalData?.goal_category_configuration_pk?.goal_category_configuration_pk}}` || null,
      }).then((res) => {
        if (res?.data?.statuscode === 200) {
          setSubTypeData({ load: false, values: res?.data?.data });
        }
      });
    } else {
      setSubTypeData({ load: false, values: [] });
    }
  };
  useEffect(() => {
    if(currentGoal?.goal_pk){
      setGoaldata({
        ...currentGoal,
        employee_id: {
          employee_id: currentGoal?.assigned_to,
          name: currentGoal?.employee_name,
        },
        goal_category_configuration_pk: {
                    goal_category_configuration_pk: currentGoal?.goal_category_config_pk, 
                    goal_category_name: currentGoal?.goal_category_name 
                  },
        goal_sub_category_configuration_pk: {
                    goal_sub_category_configuration_pk: currentGoal?.goal_sub_category_configuration_pk, 
                    goal_sub_category_name: currentGoal?.goal_sub_category_name 
                  },
        goal_status: {
          value: currentGoal?.goal_status,
          label: currentGoal?.goal_status,
        },
      });
    }
  }, [currentGoal]);
  return (
    <Box>
      <Grid container>
        <Grid item xs={12} sx={{ px: "0.75rem", py: "0.5rem" }}>
          <FormControl fullWidth>
            <SelectableSearch
              disabled={isPreview}
              label="Goal Category"
              value={goalData?.goal_category_configuration_pk}
              fieldLabel="goal_category_name"
              loading={() => handleType()}
              required={true}
              variant={"contained"}
              name="goal_category_configuration_pk"
              size="small"
              data={typeData}
              onChangeEvent={handleInputChange}
              {...(errors.goal_category_configuration_pk && {
                error: true,
                helperText: errors.goal_category_configuration_pk,
              })}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sx={{ px: "0.75rem", py: "0.5rem" }}>
          <FormControl fullWidth>
            <SelectableSearch
              disabled={isPreview}
              label="Goal"
              noOptionText="Please select goal category to choose goal."
              value={goalData?.goal_sub_category_configuration_pk}
              loading={() => handleSubType()}
              fieldLabel="goal_sub_category_name"
              name="goal_sub_category_configuration_pk"
              size="small"
              onChangeEvent={handleInputChange}
              data={subTypeData}
              required
              {...(errors?.goal_sub_category_configuration_pk && {
                error: true,
                helperText: errors?.goal_sub_category_configuration_pk,
              })}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={12} sx={{ px: "0.75rem", py: "0.5rem" }}>
          <FormControl fullWidth>
            <TextField
              disabled={isPreview}
              multiline
              rows={2}
              name="goal_desc"
              required
              value={goalData?.goal_desc}
              onChange={handleInputChange}
              label="Goal Description"
              placeholder="Write Your Goal ..."
              sx={{ width: "100%" }}
              {...(errors.goal_desc && {
                error: true,
                helperText: errors.goal_desc,
              })}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6} sx={{ px: "0.75rem", py: "0.5rem" }}>
          <FormControl fullWidth>
            <TextField
              disabled={isPreview}
              id="outlined-basic"
              label="Weightage"
              value={goalData?.weight}
              name="weight"
              required
              type="number"
              variant="outlined"
              size="small"
              onChange={(e) => {
                const value = Number(e.target.value);
                if(value <= 100) {
                  handleInputChange(e)
                }
              }}
              {...(errors.weight && {
                error: true,
                helperText: errors.weight,
              })}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6} sx={{ px: "0.75rem", py: "0.5rem" }}>
          <FormControl fullWidth error={!!errors?.alignment} size="small">
            <InputLabel id="alignment-type-label">Alignment *</InputLabel>
            <Select
              disabled={isPreview}
              labelId="alignment-type-label"
              name="alignment"
              value={goalData?.alignment}
              label="Alignment"
              onChange={handleInputChange}
            >
              <MenuItem value="Self">Self</MenuItem>
             {isAdminOwner() && 
             (<MenuItem value="Team">Team</MenuItem>)}
            </Select>
            <FormHelperText>{errors?.alignment}</FormHelperText>
          </FormControl>
        </Grid>
        {goalData?.alignment === "Team" && (
          <Grid item xs={12} md={6} sx={{ px: "0.75rem", py: "0.5rem" }}>
            <FormControl fullWidth>
              <SelectableSearch
                disabled={isPreview}
                label="Assigned To"
                loading={handleEmployees}
                value={goalData?.employee_id}
                required={true}
                variant={"contained"}
                fieldLabel={"name"}
                name="employee_id"
                size="small"
                data={employeesData}
                onChangeEvent={handleInputChange}
                {...(errors.employee_id && {
                  error: true,
                  helperText: errors.employee_id,
                })}
              />
            </FormControl>
          </Grid>
        )}
        <Grid item xs={12} md={6} sx={{ px: "0.75rem", py: "0.5rem" }}>
          <FormControl fullWidth>
            <CommonDatePicker
              disabled={isPreview}
              size="small"
              name="due_date"
              label="Due Date"
              pickerType="date"
              onKeyPress={(e) => e.preventDefault()}
              onKeyDown={(e) => e.preventDefault()}
              required={true}
              pickerFormat="dd/MM/yyyy"
              DefaultDTvalue={goalData?.due_date}
              minDate={new Date(new Date(minDojYear).getFullYear() - 1, 0, 31)}
              maxDate={new Date().setFullYear(new Date().getFullYear() + 1)}
              handleChange={(value) =>
                handleInputChange({
                  target: {
                    name: "due_date",
                    value: value
                      ? `${
                          value?.getFullYear() +
                          "-" +
                          ("0" + (value.getMonth() + 1)).slice(-2) +
                          "-" +
                          ("0" + value.getDate()).slice(-2)
                        }`
                      : "",
                  },
                })
              }
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6} sx={{ px: "0.75rem", py: "0.5rem" }}>
          <FormControl fullWidth>
            <SelectableSearch
              disabled={isPreview}
              label="Status"
              value={goalData?.goal_status}
              fieldLabel="label"
              required={true}
              variant={"contained"}
              name="goal_status"
              size="small"
              data={Statusoptions}
              onChangeEvent={handleInputChange}
              {...(errors.goal_status && {
                error: true,
                helperText: errors.goal_status,
              })}
            />
          </FormControl>
        </Grid>
      </Grid>

      <Grid
        container
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 2,
          px: "0.75rem",
          py: "0.5rem",
        }}
      >
        <Button
          onClick={handleCancel}
          sx={{
            ":hover": { color: grey[50] },
          }}
          variant="outlined"
          className="mpl-secondary-btn"
        >
          {isPreview ? "Close" : "Cancel"}
        </Button>
       { !isPreview && (<Button
          onClick={handlesubmit}
          variant="contained"
          color="primary"
          type="submit"
          className="mpl-primary-btn"
          disabled={addLoading}
          startIcon={
            addLoading ? <CircularProgress size={18} color="inherit" /> : null
          }
        >
          {currentGoal ? "Update" : "Save"}
        </Button>)}
      </Grid>
    </Box>
  );
}
